import * as React from 'react';
import { SVGProps } from 'react';

const SvgExclamationCircle = (
  props: SVGProps<SVGSVGElement> & React.HTMLAttributes<HTMLElement>
) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21c4.96 0 9-4.04 9-9s-4.04-9-9-9-9 4.04-9 9 4.04 9 9 9Zm0-16c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7Zm0 12a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11 7h2v6.5h-2V7Z"
      fill="#7B61FF"
    />
  </svg>
);
export default SvgExclamationCircle;
